import type { Platform } from '../types';

export function detectPlatform(): Platform {
  const userAgent = navigator.userAgent.toLowerCase();
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  return isMobileUA || isTouch ? 'mobile' : 'desktop';
}
